import {
  TranslationAlertMessages,
  AlertMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationAlertMessages = {
  [AlertMessages.noPermissionInvoices]: "No tiene ningún cliente al que se le permita ver las facturas.",
  [AlertMessages.noPermissionCreditLimit]: "No tiene ningún cliente al que se le permita ver el límite de crédito.",
  [AlertMessages.noPermissionCertificates]: "No tiene ningún cliente al que se le permita ver los informes.",
  [AlertMessages.noPermissionConcretingRequest]: "No tiene ningún cliente al que se le permita ver las solicitudes.",
  [AlertMessages.noPermissionInvoicesSpecificClient]: "No tiene permiso para ver las facturas de este cliente.",
  [AlertMessages.noPermissionCreditLimitSpecificClient]: "No tiene permiso para ver el límite de crédito de este cliente.",
  [AlertMessages.noPermissionCertificatesSpecificClient]: "No tiene permiso para ver los informes de este cliente.",
  [AlertMessages.noPermissionConcretingRequestSpecificClient]: "No tiene permiso de solicitud en este cliente.",
  [AlertMessages.noHaveInvoices]: "Todavía no tienes ninguna factura para ver.",
  [AlertMessages.noHaveCertificates]: "Todavía no tienes ningún informe para ver.",
  [AlertMessages.noHaveInvoicesSpecificClient]: "Este cliente aún no tiene facturas para ver.",
  [AlertMessages.noHaveCertificatesSpecificClient]: "Este cliente aún no tiene informes para ver.",
  [AlertMessages.noHaveConcretingRequestSpecificClient]: "Este cliente aún no tiene solicitudes para ver.",
  [AlertMessages.noConcretingApproval]: "Ninguna aprobación de hormigonado para ver.",
  [AlertMessages.noConcreting]: "Ninguna hormigonado para ver.",
  [AlertMessages.noContract]: "Ningún contrato para ver.",
  [AlertMessages.noUser]: "Ningún usuario para ver."
};
